// Translations
import landing from '../views/landing/translations/de'

// Translation: Two-factor authentication (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
